import styled from "styled-components";
import { COLORS, FONT_WEIGHT } from "../../../constants/Styles";

const AddressText = styled.div<{ asRadioButtonLabel?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-left: ${({ asRadioButtonLabel }) =>
    asRadioButtonLabel ? "1rem" : "0"};
  color: ${COLORS.secondaryLight};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export { AddressText };
